import { useTranslation } from 'react-i18next'
import Token from '~/components/Token'
import styled from 'styled-components'

const StyledTokenInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px;
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 56px;
  background: #fff;
`

const StyledAmountInput = styled.input`
  width: 100%;
  margin-right: 20px;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 20px;
  font-weight: 500;
  text-align: right;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textPlaceholder};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`

interface TokenInputProps {
  amount: string
  token: BaseTokenlonToken
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur: () => void
  handleOpenTokenList?: () => void
}

const TokenInput = ({
  amount,
  token,
  handleInputChange,
  handleBlur,
  handleOpenTokenList,
}: TokenInputProps) => {
  const { t } = useTranslation()
  return (
    <StyledTokenInput>
      <Token token={token} onClick={handleOpenTokenList} />
      <StyledAmountInput
        inputMode="decimal"
        placeholder={t('amount')}
        value={amount}
        onChange={handleInputChange}
        onBlur={handleBlur}
      />
    </StyledTokenInput>
  )
}

export default TokenInput
